import styled from "styled-components";

const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 70%;
  max-width: 800px;
  margin-bottom: 2rem;
`;

export default Section;
